module.exports = __webpack_public_path__ + "img/chat-square.6acfa27f.svg";